import { Box, Container, Typography, styled } from '@mui/material';
import React from 'react';

const HeroContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  minHeight: '600px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#FFFFFF',
  overflow: 'hidden',
  paddingTop: '120px',
  paddingBottom: '80px',
  backgroundImage: 'url(/images/terms/terms-hero-bg.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1,
  },
}));

const ContentContainer = styled(Container)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '48px',
}));

const SubHeading = styled(Typography)(({ theme }) => ({
  color: '#D5D7DA',
  fontSize: '16px',
  fontWeight: 600,
  textAlign: 'center',
}));

const Heading = styled(Typography)(({ theme }) => ({
  fontSize: '64px',
  fontWeight: 500,
  textAlign: 'center',
  fontFamily: 'Nohemi, sans-serif',
  lineHeight: '1em',
  [theme.breakpoints.down('md')]: {
    fontSize: '48px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '36px',
  },
}));

const SupportingText = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  textAlign: 'center',
  maxWidth: '800px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },
}));

const TermsHeroSection: React.FC = () => (
  <HeroContainer>
    <ContentContainer maxWidth="md">
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
        <SubHeading variant="subtitle1">Current as of April 11, 2025</SubHeading>
        <Heading variant="h1">Terms and Conditions</Heading>
      </Box>
      <SupportingText>
        By accessing our website, you are agreeing to be bound by these terms of service, all
        applicable laws and regulations, and agree that you are responsible for compliance with any
        applicable local laws.
      </SupportingText>
    </ContentContainer>
  </HeroContainer>
);

export default TermsHeroSection;
